// ----------------- Imports -----------------
import React from "react";
import { useRouter } from "next/router";
import { useQuery } from "@tanstack/react-query";
import fetchEventOrg from "api/event/fetchEventOrg";
import BrandingLayout from "components/brandingLayout/brandingLayout";
import { useLang } from "hooks/useLang";
import { getEventPosterUrl } from "components/atoms/Image/EventPoster";


// ----------------- Component -----------------
const EventOrganizer = () => {
    const router = useRouter();
    const { multiLangVars } = useLang();
    // Data fetcching
    const orgID = router?.query?.organizerid
    const { data, isLoading } = useQuery({
        queryKey: ["fetchOrg", orgID],
        queryFn: () => fetchEventOrg(orgID as string),
        enabled: !!orgID,
    });

    const payload = data?.payload;
    const orgData = data?.payload?.data

    // SEO values
    const name =
        orgData?.[multiLangVars("name") as "ar_name" | "en_name"] || "";

    const description =
        orgData?.[multiLangVars("description") as "ar_description" | "en_description"] || "";

    // Use the first current event's web hero image as the background poster,
    // falling back to the placeholder image if unavailable.
    const firstEvent = payload?.current?.[0];
    const posterUrl = getEventPosterUrl(firstEvent, "desktop");

    return <BrandingLayout payload={payload} subTitle="organizer" logo={orgData?.logo} posterUrl={posterUrl} data={orgData} name={name} description={description} isLoading={isLoading} />
};

export default EventOrganizer;
